import React, { createContext, useContext, useState } from 'react';

const WorkspaceTabContext = createContext(null);

export const useWorkspaceTab = () => useContext(WorkspaceTabContext);

export const WorkspaceTabProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState('raw');
    return (
        <WorkspaceTabContext.Provider value={{ activeTab, setActiveTab }}>
            {children}
        </WorkspaceTabContext.Provider>
    );
};
